import React from "react";
import { Link } from "react-router-dom";
import DeployInfraSection from "../../components/deploy/DeployInfraSection";
import DeployLegalFooter from "../../components/deploy/DeployLegalFooter";

export default function DeployInfrastructurePage() {
  return (
    <div className="min-h-screen bg-black text-silver-light px-4 py-8 sm:px-6 font-sans">
      <div className="max-w-5xl mx-auto space-y-6">
        <div className="flex items-center gap-3">
          <Link
            to="/limelite/deploy/dashboard"
            className="text-sm text-silver-medium hover:text-silver-light transition-colors"
          >
            ← Dashboard
          </Link>
        </div>
        <DeployInfraSection />
        <DeployLegalFooter />
      </div>
    </div>
  );
}
